export default "__VITE_ASSET__rWCJBjaF__"